import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
const dropdownItems = {
    Seed: [
      "Seed",
      "Seed",
      "Seed",
      "Seed",
      "Seed",
      "Seed",
      "Seed",
      "Seed",
  
    ],
    Fertizilar: [
      "Fertizilar",
      "Fertizilar",
      "Fertizilar",
      "Fertizilar",
      "Fertizilar",
      "Fertizilar",
      "Fertizilar",
      "Fertizilar",
  
    ],
    Herbicides: [
      "Herbicides",
      "Herbicides",
      "Herbicides",
      "Herbicides",
      "Herbicides",
      "Herbicides",
      "Herbicides",
      "Herbicides",
  
    ],
    PESTICIDES: [
      "PESTICIDES",
      "PESTICIDES",
      "PESTICIDES",
      "PESTICIDES",
      "PESTICIDES",
      "PESTICIDES",
      "PESTICIDES",
      "PESTICIDES",
  
    ],
  
  };
  
  const dropdownIcons = {
    PESTICIDES:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744492909/Pin_alt_ioedjs.png",
      Herbicides:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
  
      Fertizilar:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493134/Order_ytgysy.png",
    Seed:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493133/image_fdtjzb.png",
    LIVESTOCK:
      "https://res.cloudinary.com/dzngpgki4/image/upload/v1744493189/image_34_zwohkn.png",
  };
  
  const Dropdown = ({ label, items, type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(items[0]);
  
    const icon = dropdownIcons[type];
  
    return (
      <div className="flex flex-col w-full relative ">
        {/* Label */}
  
        {/* Button + Icon Container */}
        <div className="flex relative z-20 w-fit">
          {/* Dropdown Button */}
          <button
            onClick={() => setIsOpen((prev) => !prev)}
            className="xl:w-[270px] lg:w-[140px] md:w-[55px] w-[40px] h-[15px] md:h-[40px] bg-[#2E453D] text-white font-bold flex justify-between items-center px-3 rounded-l-[10px]"
          >
            <span className="md:text-[14px] md:px-4 text-[4px] md:mt-0 mt-[2px]">{selected}</span>
          </button>
  
          {/* Icon Box */}
          <div
            className="w-[20px] h-[15px] md:h-[40px] md:w-[40px] bg-[#152C24] text-white flex justify-center items-center rounded-[10px] -ml-2 z-30 cursor-pointer"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
              alt="expand"
              className="w-3 h-3 md:w-5 md:h-5"
            />
          </div>
        </div>
  
        {/* Dropdown List */}
        {/* Dropdown List */}
        <AnimatePresence>
          {isOpen && (
            <motion.ul
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="absolute top-full mt-1 left-0 z-50 md:w-[270px] w-[100px] bg-white/90 rounded-lg shadow-lg"
            >
              {items.map((item, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setSelected(item);
                    setIsOpen(false);
                  }}
                  className="md:p-3 p-1 bg-[#CFD7D7] md:mt-1 md:text-[18px] text-[10px] rounded-md hover:bg-[#afafaf] cursor-pointer flex items-center"
                >
                  <img src={icon} className="md:w-4 md:h-4 h-2 w-2 mr-2" alt="icon" />
                  <span className="text-black">{item}</span>
                </li>
              ))}
            </motion.ul>
          )}
        </AnimatePresence>
  
  
  
      </div>
  
  
  
    );
  };
  const data = Array(5).fill({
    date: "07/07/2025",
    opening: "20000",
    closing: "20000",
    value: "2000",
  });
  const renderTable = (title, type, dropdownType) => (
  <div className="w-full font-sans text-[10px] md:text-[32px] md:mt-5">
    <div className="flex justify-between items-center mb-2 md:mb-1 md:mt-5">
      <div className="flex justify-between">
        {title && (
          <div className={`${title === "INVENTORY" ? "-mb-12" : ""}`}>
            <h2 className="text-[#F38323] font-bold text-[8px] md:text-[20px]">
              {title}
            </h2>
          </div>
        )}
        <div className="w-10"></div>
        {dropdownItems[dropdownType] && (
          <Dropdown
            label={
              {
                Seed: "Crop Report",
                Fertilizer: "Fertilizer Report",
                Herbicides: "Herbicides Report",
              }[dropdownType] || dropdownType
            }
            items={dropdownItems[dropdownType]}
            type={dropdownType}
          />
        )}
      </div>
    </div>
  
    <table className="w-full table-fixed  border-separate border-spacing-y-1 md:-mt-3">
      <thead>
        <tr>
          <th className="text-left font-bold w-auto md:w-[140px] text-[6px] md:text-[20px]">
            {type.toUpperCase()}
          </th>
          <th className="text-left font-normal w-auto md:w-[140px]">
            Opening Stock <strong>(t)</strong>
          </th>
          <th className="text-left font-normal w-auto md:w-[140px]">
            Closing Stock <strong>(t)</strong>
          </th>
          <th className="text-left font-normal w-auto md:w-[140px]">
            Value <strong>(Rands)</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px]">
              {row.date}
            </td>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#E7EBEB]">
              {row.opening}
            </td>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#CFD7D7]">
              {row.closing}
            </td>
            <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-auto md:w-[140px] bg-[#9FAFAF] text-black">
              {row.value}
            </td>
          </tr>
        ))}
        <tr>
          <td className="h-[5px]"></td>
        </tr>
        <tr className="font-bold">
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px]">TOTAL</td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#E7EBEB]">20000</td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#CFD7D7]">20000</td>
          <td className="p-1 md:p-2 h-[25px] md:h-[50px] w-[140px] bg-[#9FAFAF] text-black">2000</td>
        </tr>
      </tbody>
    </table>
  </div>
  
  );
  
  
  const renderDropdown = (type) => {
    const customLabels = {
      Seed: "Crop Report",
      Fertizilar: "Fertilizer Report",
      Herbicides: "Herbicides Report",
    };
  
    return (
      <div className="flex justify-end   md:gap-2 gap-[1px] md:mt-12 w-full sm:w-auto">
   <div>
   {Object.keys(dropdownItems)
          .filter((itemType) => itemType === type)
          .map((itemType) => (
            <Dropdown
              key={itemType}
              label={customLabels[itemType] || itemType}
              items={dropdownItems[itemType]}
              type={itemType}
            />
          ))}
   </div>
      </div>
    );
  };
const ReportTable = () => {
  return (
    <div>
          <div className="w-full">
      {/* Inventory Section */}
      {renderTable("INVENTORY", "")}
      {renderDropdown("Seed")}

      {/* Inputs - Seed */}
      {renderTable("INPUTS", "Seed")}
      {renderDropdown("Fertizilar")}

      {/* Fertilizer Table */}
      {renderTable("", "Fertilizer")}
      {renderDropdown("Herbicides")}

      {/* Herbicides Table */}
      {renderTable("", "Herbicides")}
    </div>
    </div>
  )
}

export default ReportTable